<div class="modal fade {{showLoader? 'show' : ''}}" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="false" >
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body ">
        <div class="d-flex justify-content-center align-items-center ">
          <div class="spinner-border text-white" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div class="text-center text-white mt-3">Please wait while we service your request.</div>
      </div>
    </div>
  </div>
</div>